import { Injectable } from "@angular/core";
import {HttpClient,HttpHeaders} from "@angular/common/http"
// import 'rxjs/add/operator/map';
import { MkmModel } from "../models/mkm.model";
import { ConfigService } from "../shared/utils/config.service";
import { Observable, map } from "rxjs";


@Injectable()
export class MkmService {
    baseUrl: string = '';

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
    };

    getAllMkms() {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/mkms', { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    getMkm(id: number) {
        //let headers = new HttpHeaders();
        //headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/mkms/' + id)
            .pipe(map((res:any) => {
                return res;
            }));
    }

    getMkmCityId(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/mkmcity/' + id, { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    getMkmsWeb(catID:number, filter:string) {
        return this.http.get(this.baseUrl + '/mkmweb/' + catID.toString() + '?filter=' + filter)
            .pipe(map((res:any) => {
                return res;
            }));
    }

    getMkmPoi() {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/mkmpoi', { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    create(mkm: MkmModel) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.post(this.baseUrl + '/mkms', mkm, { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

   addImageIntoMkms(mkmId: number, image: File): Observable<any> {
        const formData = new FormData();
        formData.append('MkmId', mkmId.toString());
        formData.append('Image', image);

        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers);

        return this.http.post(this.baseUrl + '/mkms/addimage', formData, { headers: headers })
            .pipe(map((res: any) => {
                console.log(res,"Response after api call")
                return res;
            }));
    }

    addImageIntoTzadikim(mkmId: number, image: File): Observable<any> {
        const formData = new FormData();
        formData.append('MkmId', mkmId.toString());
        formData.append('Image', image);

        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers);

        return this.http.post(this.baseUrl + '/tzadikims/addimages', formData, { headers: headers })
            .pipe(map((res: any) => {
                console.log(res,"Response after api call")
                return res;
            }));
    }

    update(mkm: MkmModel) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.put(this.baseUrl + '/mkms/' + mkm.id, mkm, { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    delete(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.delete(this.baseUrl + '/mkms/' + id, { headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    deleteMkmImage(id:number){
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.delete(this.baseUrl + '/mkms/DeleteMkmImage?mkmImageId=' + id, { headers: headers })
        .pipe(map((res:any)=>{
            return res;
        }))
    }

    getPoiList() {
        return this.http.get(this.baseUrl + '/mkm/poilist')
            .pipe(map((res:any) => {
                return res;
            }));
    }

    getMkmByPoi(poi: number) {
        return this.http.get(this.baseUrl + '/mkmbypoi/' + poi)
            .pipe(map((res:any) => {
                return res;
            }));
    }
}